module.exports = __webpack_public_path__ + "13ec0eb5bdb821ff4930237d7c9f943f.woff2";